import React from 'react';
type CabModifySearchCollapsedProps = {
  title: string;
  travelFor: string;
  departDate: string;
  returnDate: string;
  isMultiCity?: boolean;
  setcollapsableFlag: React.Dispatch<React.SetStateAction<boolean>>;
};

const CabModifySearchCollapsed = ({
  title,
  travelFor,
  departDate,
  returnDate,
  isMultiCity,
  setcollapsableFlag
}: CabModifySearchCollapsedProps) => {
  return (
    <div className="cabModifySearchCollapsedWrap">
      <p className="font16 latoBold appendBottom5 whiteText"> {title} </p>
      <p style={{ color: '#a7aebb' }} className="font12 appendBottom2">
        <span>
          {' '}
          {travelFor} <span className="appendLeft5 appendRight5">|</span>{' '}
        </span>
        <span> {departDate} </span>
        {(isMultiCity || travelFor === 'Outstation Round-trip') && (
          <span> {` → ${returnDate}`} </span>
        )}
      </p>
      <p title="Modify search for Cabs" className="widgetSearchBtn--wrap">
        <button
          onClick={() => {
            setcollapsableFlag(false);
          }}
          className="bluePrimarybtn widgetSearchBtn"
        >
          Modify Search
        </button>
      </p>
    </div>
  );
};

export default CabModifySearchCollapsed;
